export default "__VITE_PUBLIC_ASSET__321943d9__"